import React from 'react';
import Button from 'wonderbly-components/lib/Button';
import PropTypes from 'prop-types';

const CallToAction = props => (
  <Button
    colour={props.color}
    className="hero-button"
    outlined>
    {props.cta}
  </Button>
);

CallToAction.propTypes = {
  cta: PropTypes.string,
  color: PropTypes.string,
  outlined: PropTypes.bool,
  raised: PropTypes.bool
};

export default CallToAction;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Hero/CallToAction/CallToAction.js